// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__DzvA1","greyed-out":"styles_greyed-out__PHWTh","name":"styles_name__6mIrh","tagDescription":"styles_tagDescription__rpqrJ"};